/* eslint-disable react/no-unescaped-entities */
import dynamic from "next/dynamic";
import React from "react";

const AgreementPartialLayout = dynamic(
  () => import("../generic/agreement-partial-layout"),
  { ssr: false }
);

let sections = [
  {
    header: "Enrolling in the Program",
    content: (
      <span>
        To begin the enrollment process, you will submit a completed Affiliates
        Program Application via the Shipvista.com site. We will evaluate your
        application in good faith and will notify you of your acceptance or
        rejection. We may reject your application if we determine, in our sole
        discretion, that your site is unsuitable for the Affiliates Program for
        any reason. Unsuitable sites include, but are not limited to, those
        that: promote sexually explicit materials; promote violence; promote
        discrimination based on race, sex, religion, nationality, disability,
        sexual orientation or age; promote illegal activities; or violate
        intellectual property rights. If we reject your application, you may
        reapply to the Affiliates Program at any time, and we will reconsider
        your application.
      </span>
    ),
  },
  {
    header: "Linking To Our Site",
    content: (
      <span>
        On your site, you may place Site Links to pages on the Shipvista.com
        site. For purposes of this Agreement, a "Site Link" is a hypertext link
        comprised of a URL and a Shipvista.com-approved graphic, available from
        our site. The URL also incorporates unique Affiliates Program Identifier
        Information which will be provided to you by Shipvista.com, or its
        agent. Once accepted, you may add or delete Site Links from your site at
        any time without our approval. Each Site Link must connect directly to
        the Shipvista.com site. You may not transmit "interstitial advertising"
        to users as they link from your site to the Shipvista.com site, or
        otherwise interrupt such link through the use of any intermediate screen
        or device, including without limitation the use of any html pop-up
        window. In addition, you may not frame, or otherwise create a border
        environment or browser around, the Shipvista.com site, or the contents
        thereof. You will be solely responsible for properly incorporating the
        Affiliates Program Identifier Information into your Site Link and
        testing the Site Link to ensure that it operates properly.
      </span>
    ),
  },
  {
    header: "Order Processing",
    content: (
      <span>
        We will process orders placed by customers accessing our site via a Site
        Link in accordance with our standard business practices. We will be
        responsible for all aspects of order processing and fulfillment. We
        reserve the right to reject orders that do not comply with any
        requirements that we periodically may establish. Customers who buy
        products from us through the Affiliates Program will be deemed to be
        customers of Shipvista.com. Accordingly, all Shipvista.com rules,
        policies, and operating procedures concerning customer orders, customer
        service, and prices will apply to the customers who use your Site Links
        to get to our site. We may change our policies and operating procedures
        at any time, with or without notice
      </span>
    ),
  },
  {
    header: "Commissions",
    content: (
      <span>
        <div>
          <h5 id="four">Commissions</h5>
          <p>
            During the term of this Agreement, we will pay you in Canadian
            Dollars (CAD $) as follows;
          </p>
          <ol>
            <li>
              Earn a $0.01 per Click commission for every new real Click on your
              referral link.
            </li>
            <li>
              Earn a $0.02 commission for every new customer who signs up using
              your referrals.
            </li>
          </ol>
          <p>and</p>
          <ol>
            <li>
              Earn a commission per label for every shipment(Parcel, LTL
              Freight, Skid shipment etc.,) created and sent by your referrals
              for the first 90 days (3 months) using our Shipvista.com’s default
              carrier accounts, including Canada Post, Purolator, UPS, USPS, DHL
              Express, Tforce Freight, Apex, and Day and Ross among others.
              <div className="p-2">
                <table className="mt-4 table table-bordered w-75">
                  <tbody>
                    <tr>
                      <td>#</td>
                      <td>Per Label Amount(in $)</td>
                      <td>Earn</td>
                    </tr>
                    <tr>
                      <td>1</td>
                      <td>$0 - $199.99</td>
                      <td>Earn a $0.10 per label commission</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>$200 - $999.99</td>
                      <td>Earn 2% per label commission</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>$1000 and above</td>
                      <td>Earn 5% per label commission</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div>
                Example: If a person you referred created a shipment on our
                platform
                <ul>
                  <li>
                    for postage amount worth $10 per label you will receive
                    $0.10 for that shipping label.
                  </li>
                  <li>
                    for postage amount worth $195 per label you will receive
                    $0.10 for that shipping label.
                  </li>
                  <li>
                    for postage amount worth $250 per label you will receive
                    2%(i.e. $5) for that shipping label.
                  </li>
                  <li>
                    for postage amount worth $1100 per label you will receive
                    5%(i.e. $55) for that shipping label.
                  </li>
                </ul>
              </div>
            </li>
            <li>
              Earn a $5.00 commission for each New REFERRALS that signs up with
              any of our Paid Subscription Plans, including Professional,
              Enterprise, and customizable Plans among other paying plans.
            </li>
          </ol>
          <br />
          <p>
            For purposes of this Agreement, "New Customer" means a customer who
            (i) directly accesses our site from your assigned affiliate link on
            your website or email , (ii) registers with Shipvista.com for the
            Shipvista.com Internet PostageTM service using a unique credit card
            number or Automated Clearing House (ACH) number, electronic mail
            address and name not previously received by us, (iii) is
            successfully billed for at least one complete Shipvista.com billing
            cycle, and (iv) uses a promotional code assigned to you under the
            Affiliates Program. You may not, directly or indirectly, offer any
            person or entity any consideration or incentive for using the Site
            Links on your site to access the Shipvista.com site. If we
            determine, in our sole discretion, that you are in violation of the
            foregoing sentence, we may withhold any commissions otherwise
            payable to you pursuant to the terms hereof, in addition to all
            other remedies available to us.
          </p>
        </div>
      </span>
    ),
  },
  {
    header: "Commission Payment",
    content: (
      <span>
        Commission payments will be paid each calendar month within
        approximately forty-five (45) days following the end of such month. We
        may require you to give us additional information, in order for us to
        comply with any applicable tax reporting requirements. You hereby agree
        to provide such information as it may be reasonably requested by us for
        such purposes.
        <br />
        <br />
        We, or our agent, will provide you with access to a password-protected
        site to view reports summarizing your Site Link activity. The form and
        content of the reports may vary from time to time at our discretion. To
        permit accurate tracking, reporting, and fee accrual, you must ensure
        that the Site Links between your site and our site are properly
        formatted. Failure to properly format and use the Site Links may result
        in a reduction to amounts which would otherwise be paid to you pursuant
        to the terms hereof or the termination of this Agreement.{" "}
      </span>
    ),
  },
  {
    header: "Limited License",
    content: (
      <span>
        In your Site Links, you agree to use only those graphic images that we
        provide, and further agree to update such images with any new images we
        provide. You may not alter the look, feel or functionality of the
        graphics in any way without Shipvista.com's prior written permission. We
        grant you a limited, non-exclusive, revocable, non-transferable right to
        use the Shipvista.com Commission Program graphics and such other images
        for which we grant express permission, solely for the purpose of
        identifying your site as a Shipvista.com Commission Program participant.
        We reserve all of our rights in the graphics and all other intellectual
        property rights. We may revoke your license at any time by giving you
        written notice. You acknowledge that we may desire to use Commission
        Program members' names and logos in press releases, product brochures
        and financial reports indicating that you are a member of the
        Shipvista.com Commission Program, and you agree that we may use your
        name and logo in such a manner.{" "}
      </span>
    ),
  },
  {
    header: "Trademarks",
    content: (
      <span>
        You agree to comply with Shipvista.com's Trademark Usage Guidelines
        located on our site, and any other guidelines provided by Shipvista.com.
        You acknowledge that the Shipvista.com Trademarks, which include without
        limitation the symbols, trademarks and service marks used by
        Shipvista.com to identify its products and/or services, belong solely to
        Shipvista.com and that members of the Affiliates Program have no rights
        in such Trademarks except for the purpose of displaying Site Links on
        the Affiliate's site(s) in accordance with the provisions of this
        Agreement. Any goodwill arising from the use of our Trademarks hereunder
        will belong to Shipvista.com. At no time during or after the term of
        this Agreement will you challenge or assist others to challenge our
        Trademarks or the registration thereof or attempt to register any
        trademarks, marks or trade names confusingly similar to the Trademarks.
        At our reasonable request, all depictions of our Trademarks that you
        intend to use will be submitted to us for approval of design, color of
        other details. In the event we do not approve of such depiction, you
        will cease using such depiction immediately upon notice. The provisions
        of this section will survive expiration or termination of this Agreement
        for any reason.{" "}
      </span>
    ),
  },
  {
    header: "Terms of the Agreement",
    content: (
      <span>
        The term of this Agreement will begin upon your receipt of written
        notification from Shipvista.com of its acceptance of your Application
        and will end when terminated by either party. Either you or we may
        terminate this Agreement at any time, with or without cause, by giving
        the other party written notice of termination. Upon the termination of
        this Agreement for any reason, you will immediately cease all use of
        Shipvista.com's Trademarks, and remove from your site(s), all Site
        Links, and all other materials provided by or on behalf of us to you in
        connection with the Affiliates Program. You are only eligible to earn
        commissions during the term. We may withhold your final payment for a
        reasonable time to ensure that the correct amount is paid. Notification
        via e-mail to your address in our records will be deemed to have been
        delivered and given for all purposes on the delivery date. Any notice
        required or permitted hereunder shall be sent to the following address:
        Affiliate Program, Shipvista.com Corporation, U9 9 Royalcrest Rd
        Etobicoke, ON M9V 2L6, with a copy to Legal Department.{" "}
      </span>
    ),
  },
  {
    header: "Warranty and Disclaimer",
    content: (
      <span>
        You warrant that you have full power and authority to enter into this
        Agreement, and that the entering into and performance of this Agreement
        by you will not violate, conflict with, or result in a default under any
        other contract or agreement to which you are a party. You warrant that
        your site(s) will not infringe, violate or misappropriate any copyright,
        trade secret, trademark, or other proprietary or intellectual property
        right of any third party or constitute libel, defamation, invasion of
        privacy or the violation of any right of publicity or any other right of
        any third party. You are solely responsible for the development,
        operation, maintenance and content of your site(s). Shipvista.com will
        not be responsible for any of the foregoing. You agree to indemnify and
        hold Shipvista.com, and its directors, officers, affiliates, employees
        and agents, harmless from all liability, claims, damages and expenses
        (including without limitation attorneys' fees, court costs and costs of
        other professionals) relating to or arising from the development,
        operation, maintenance and contents of your site(s); and/or any breach
        by you of any representation, warranty or agreement made herein. <br />
        <br />
        THE SITE LINKS, AND ALL OTHER DOCUMENTATION AND SERVICES ARE PROVIDED BY
        SHIPVISTA.COM "AS IS." WE MAKE NO PROMISES, WARRANTIES, OR
        REPRESENTATIONS OF ANY KIND, AND WE SPECIFICALLY DISCLAIM ALL WARRANTIES
        AND CONDITIONS, EXPRESS, IMPLIED, STATUTORY OR OTHERWISE, WITH RESPECT
        TO THE SUBJECT MATTER HEREOF, INCLUDING BUT NOT LIMITED TO IMPLIED
        WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
        NON-INFRINGEMENT. WE MAKE NO REPRESENTATION OR WARRANTY THAT THE
        OPERATION OF OUR SITE WILL BE UNINTERRUPTED OR ERROR FREE OR THAT OUR
        PRODUCTS WILL BE AVAILABLE FOR PURCHASE FROM THE SHIPVISTA.COM SITE. THE
        PROVISIONS OF THIS SECTION WILL SURVIVE EXPIRATION OR TERMINATION OF
        THIS AGREEMENT FOR ANY REASON.{" "}
      </span>
    ),
  },
  {
    header: "Limitation of Liability",
    content: (
      <span>
        IN NO EVENT WILL WE BE LIABLE TO YOU FOR LOSS OF PROFITS, LOSS OF
        BUSINESS OPPORTUNITIES, LOSS OF USE, LOSS OF DATA, INTERRUPTION OF
        BUSINESS, COST OF PROCUREMENT OF SUBSTITUTE GOODS AND SERVICES, OR FOR
        ANY SPECIAL, CONSEQUENTIAL, EXEMPLARY, INDIRECT OR INCIDENTAL DAMAGES,
        ARISING OUT OF OR RELATED TO THIS AGREEMENT OR THE AFFILIATES PROGRAM,
        HOWEVER CAUSED, AND WHETHER ARISING UNDER CONTRACT, TORT (INCLUDING
        NEGLIGENCE) OR ANY OTHER THEORY OF LIABILITY. THE LIMITS SET FORTH IN
        THIS SECTION WILL APPLY EVEN IF SHIPVISTA.COM HAS BEEN ADVISED OF THE
        POSSIBILITY OF SUCH DAMAGES. IN NO EVENT WILL OUR AGGREGATE LIABILITY
        UNDER THIS AGREEMENT EXCEED THE TOTAL COMMISSIONS PAID TO YOU UNDER THIS
        AGREEMENT FOR THE TWELVE (12) MONTHS PRIOR TO THE EVENT GIVING RISE TO
        SUCH LIABILITY. THE PROVISIONS OF THIS SECTION WILL SURVIVE EXPIRATION
        OR TERMINATION OF THIS AGREEMENT FOR ANY REASON.
      </span>
    ),
  },
  {
    header: "Confidentiality",
    content: (
      <span>
        During the term of this Agreement, you may have access to certain
        non-public information of Shipvista.com, which information a reasonable
        person would consider confidential or which is marked as "confidential"
        or "proprietary" ("Confidential Information"). Confidential Information
        does not include information that is generally known and available, or
        in the public domain through no fault of yours. You agree (i) not to
        disclose any Confidential Information to any third parties, (ii) not to
        use any Confidential Information for any purposes except carrying out
        your rights and responsibilities under this Agreement, and (iii) to keep
        the Confidential Information confidential using the same degree of care
        you use to protect your own confidential information, as long as you use
        at least reasonable care. These obligations will survive for three years
        after expiration or termination of this Agreement for any reason.{" "}
      </span>
    ),
  },
  {
    header: "Independent Investigation",
    content: (
      <span>
        YOU ACKNOWLEDGE THAT YOU HAVE READ THIS AGREEMENT AND AGREE TO ALL ITS
        TERMS AND CONDITIONS. YOU UNDERSTAND THAT WE MAY AT ANY TIME (DIRECTLY
        OR INDIRECTLY) SOLICIT CUSTOMER REFERRALS ON TERMS THAT MAY DIFFER FROM
        THOSE CONTAINED IN THIS AGREEMENT OR OPERATE SITES THAT ARE SIMILAR TO
        OR COMPETE WITH YOUR SITE(S). YOU HAVE INDEPENDENTLY EVALUATED THE
        DESIRABILITY OF PARTICIPATING IN THE AFFILIATES PROGRAM AND ARE NOT
        RELYING ON ANY REPRESENTATION, GUARANTEE, OR STATEMENT OTHER THAN AS SET
        FORTH IN THIS AGREEMENT.
      </span>
    ),
  },
  {
    header: "General",
    content: (
      <span>
        You and Shipvista.com are independent contractors, and nothing in this
        Agreement will create any partnership, joint venture, agency, franchise,
        sales representative, or employment relationship between you and
        Shipvista.com. You understand that you do not have authority to make or
        accept any offers or make any representations on behalf of
        Shipvista.com. You may not make any public statement, press release or
        other announcement relating to the terms or existence of this Agreement,
        or your participation in the Affiliates Program, without the prior
        written consent of Shipvista.com. If any provision of this Agreement is
        held unenforceable, that provision will be enforced to the maximum
        extent permissible so as to effect the intent of the parties, and the
        remainder of this Agreement will continue in full force and effect. We
        may modify any of the terms and conditions contained in this Agreement,
        at any time and in our sole discretion, by posting a change notice or a
        new agreement on our site. If any modification is unacceptable to you,
        your only recourse is to terminate this Agreement. Your continued
        participation in the Affiliates Program following our posting of a
        change notice or new agreement on our site will constitute binding
        acceptance of the change. You may not assign or otherwise transfer this
        Agreement or any of your rights or duties under this Agreement, without
        our prior written consent. This Agreement will inure to the benefit of
        Shipvista.com, its successors, administrators, heirs, and assigns. This
        Agreement is governed by the laws of the province of Ontario, without
        reference to its conflict of law principles and without regard to the
        1980 U.N. Convention on Contracts for the International Sale of Goods.
        This Agreement constitutes the complete and exclusive understanding and
        agreement of Shipvista.com and you relating to the subject matter hereof
        and supersedes all prior or contemporaneous understandings, agreements,
        and communications (including advertisements), whether oral or written,
        between the parties.{" "}
      </span>
    ),
  },
];

let annex = {
  header: {
    title: "ANNEX A - TERMS AND CONDITIONS FOR SECONDARY-AFFILIATES",
    notice: `This Annex A contains the complete terms and conditions subject to which Affiliate may allow party's
        participating in its sub-affiliate sales channel program to place Site Links to pages on the
        Shipvista.com site. `,
  },
  content: [
    {
      header: "Site Links",
      content: (
        <span>
          Affiliate may allow party's participating in its sub-affiliate sales
          channel program ("SecondaryAffiliates") to place Site Links to pages
          on the Shipvista.com site; provided that Affiliate enters into a
          written agreement with each participating Secondary-Affiliate which is
          at least as protective of Shipvista.com as the terms and conditions
          set forth herein, which agreement shall also contain a provision
          making Shipvista.com a direct and intended third party beneficiary,
          and Affiliate further agrees to diligently enforce such agreements. In
          addition to the requirements set forth in the Agreement, each
          Secondary-Affiliate Site Link shall also include an Identifier to be
          provided by Affiliate in accordance with the instructions provided by
          us, or our agent, which Identifier shall be unique to each
          Secondary-Affiliate. Affiliate shall be solely responsible for
          properly incorporating the Identifier into the Secondary Affiliate
          Site Links, and for testing such Site Links to ensure proper
          operation. Failure to properly format and use the Site Links may
          result in a reduction to amounts which would otherwise be paid to you
          pursuant to the terms hereof or the termination of the Agreement
        </span>
      ),
    },
    {
      header: "Reports",
      content: (
        <span>
          We, or our agent, will provide you with access to a password protected
          site to view reports ("Reports") summarizing Secondary-Affiliate Site
          Link activity. The form and content of the Reports may vary from time
          to time in our discretion. The information contained in the Reports
          shall be deemed the Confidential Information of Shipvista.com, and as
          such you may not disclose to any third party, nor provide, or permit
          any third party to view or access, such Reports. You may not use the
          Reports, or any data therein, for any purpose other than as expressly
          set forth herein. You may not independently track Secondary-Affiliate
          activity using such Secondary Affiliate's Identifier, nor may you use
          such Identifier to track or identify individual end users, or such end
          users activity.
        </span>
      ),
    },
    {
      header: "Payments",
      content: (
        <span>
          You shall be solely responsible for the payment of any and all
          consideration due and owing to your Secondary-Affiliates.
        </span>
      ),
    },
    {
      header: "Indemnification",
      content: (
        <span>
          In addition to the indemnification provisions set forth above, you
          agree to indemnify and hold Shipvista.com, and its directors,
          officers, affiliates, employees and agents, harmless from all
          liability, claims, damages and expenses (including without limitation
          attorneys' fees, court costs and costs of other professionals)
          relating to or arising from the use of Site Links by a
          Secondary-Affiliate, and/or any use by you of the Reports or the
          Identifier that is not in strict compliance with the terms hereof.
        </span>
      ),
    },
  ],
};

const CommissionProgramAgreementMain = () => {
  return (
    <AgreementPartialLayout
      title="Shipvista.com Commission Program Agreement"
      subtitle="Last Updated: February 1st, 2022"
    >
      {({ handleRef }) => (
        <>
          <p style={{ fontWeight: 600 }}>
            This Commission Program Agreement (“Terms” or “Agreement”), is a
            legal agreement between you and Shipvista.com Corporation.
            (“Shipvista.com,” “Company,” “us,” or “our”) and govern your use of
            this website or any software downloaded from this website, your
            Shipvista.com account. In addition to our Terms of Use on our site,
            contains the complete terms and conditions that apply to an
            individual's or entity's participation in the Shipvista.com
            Commission Program (the "Affiliates Program" or the “Referral
            Program"). In this document, "you" refers to the Affiliates Program
            applicant, and "we" and "us" refer to Shipvista.com. "Site" refers
            to an Internet website. By completing an Affiliates Program
            Application and clicking on the "Apply" button below, you agree to
            be bound by the terms of this Agreement
          </p>
          <ol>
            {sections.map((section, i) => {
              const sectionId = `${section.header.replace(/\s/g, "")}-${i}`;
              return (
                <>
                  <br />
                  <li>
                    <div>
                      <h5
                        ref={
                          handleRef(
                            `${i + 1}. ${section.header}`,
                            sectionId
                          ) as any
                        }
                        id={sectionId}
                      >
                        <span>{section.header}</span>
                      </h5>
                      <p>{section.content}</p>
                    </div>
                  </li>
                </>
              );
            })}
          </ol>
          <br />
          {annex && (
            <div>
              <h5>{annex.header.title}</h5>
              <br />
              <section>
                <p>{annex.header.notice}</p>
              </section>
              <ol>
                {annex.content.map((a, i) => {
                  return (
                    <>
                      <br />
                      <li id={`${a.header.replace(/\s/g, "")}-${i}`}>
                        <h6>
                          <span>{a.header}</span>
                        </h6>
                        <section>
                          <p>{a.content}</p>
                        </section>
                      </li>
                    </>
                  );
                })}
              </ol>
            </div>
          )}
          <p>
            <strong>Disclosure:</strong> ShipVista.com use and transfer of
            information received from Google APIs to any other app will adhere
            to{" "}
            <a
              target="_blank"
              href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes"
              rel="noreferrer"
            >
              Google API Services User Data Policy
            </a>
            , including the Limited Use requirements, and subject to the
            <a
              target="_blank"
              href="https://play.google.com/about/developer-distribution-agreement.html"
              rel="noreferrer"
            >
              {" "}
              Google Play Developer Distribution Agreement
            </a>
            .
          </p>
        </>
      )}
    </AgreementPartialLayout>
  );
};

export default CommissionProgramAgreementMain;
